import { createReducer, on } from '@ngrx/store';
import { MembershipListApiActions, UserApiActions } from './user-group.actions';
import { adapter, initialstate, selectUserIdFromParent } from './user-group.state';

export const userGroupReducer = createReducer(
  initialstate,
  on(UserApiActions.userGroupsLoaded, (state, { groups }) => adapter.addMany(groups, state)),
  on(MembershipListApiActions.userGroupDeleted, (state, { group, user }) =>
    adapter.removeOne(selectUserIdFromParent({ ...group, userId: user.id }), state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectUserIds = selectIds;

export const selectUserEntities = selectEntities;

export const selectAllGroups = selectAll;
